export const TOAST_MESSAGES = {
    USER_LEDGER_FETCH_FAILED: "Failed to fetch user ledger!",
    USER_LEDGER_FETCH_ERROR: "Error fetching user ledger!",
    FAIL_USERS_FETCH: "Failed to fetch users",
    ERROR_USERS_FETCH: "Error fetching users",
}

export const MISC = {
    NOT_AVAILABLE: "N/A",
    NO_PROJECT_LEDGER_FOUND: "No Ledger found for this project",
    NO_USER_LEDGER_FOUND: "No Ledger found for this user"
}

export const LEDGER_COLUMNS = [
    "approved_on",
    "note_type",
    "site_name",
    "before_amount",
    "transaction_amount",
    "balance",
    "approved_by_name",
    "actions",
];

export const LEDGER_LABELS = {
    approved_on: "Transaction Date",
    note_type: "Transaction Type",
    approved_by_name: "Approved By",
    site_name: "Site",
    before_amount: "Before Transaction Amount",
    transaction_amount: "Transaction Amount",
    balance: "Balance",
    actions: "Actions",
};

export const TRANSACTION_TYPE_LEDGER = {
    ADVANCE_NOTE: "ADVANCE_NOTE",
    BILL: "BILL"
}

export const TRANSACTION_TYPE_LEDGER_LABEL = {
    ADVANCE_NOTE: "Advance Note",
    BILL: "Bill"
}